import { useParams } from "react-router-dom";

/**
 * Identifiant du document affiché par l'onglet « Pièces jointes » : `idInvoice` sur le détail facture,
 * `idAvoir` sur le détail avoir, qui réutilise cet onglet. Le serveur reconnaît un avoir à son identifiant
 * (factures et avoirs partagent la même numérotation) : les mêmes routes servent aux deux.
 */
export default () => {
	const { idInvoice, idAvoir } = useParams();
	return idInvoice || idAvoir;
};
